import { postData } from './api';
import { ApiEmptyResponse, ResponseData } from './models';

export const show = async (
  sessionPageReference: string,
  showingReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  postData(`api/navigation/show`, {
    sessionPageReference,
    showingReference
  });
export const blank = async (
  sessionPageReference: string,
  showingReference: string
): Promise<ResponseData<ApiEmptyResponse>> =>
  postData(`api/navigation/show`, {
    sessionPageReference,
    showingReference,
    showBlank: true
  });
